import { ClientTrackingPage } from '@models/client-tracking-page';
import Routes from '@models/routes';

const routePageViewMap = {
    [Routes.Authorisation]: ClientTrackingPage.PinCodeAuthorisation,
    [Routes.Section3Review]: ClientTrackingPage.Section3Review,
    [Routes.Section2Documents]: ClientTrackingPage.Section2DocumentReview,
    [Routes.Section2EmployeeInformation]: ClientTrackingPage.Section2EmployeeInformation,
    [Routes.Section2ThankYou]: ClientTrackingPage.Section2ThankYou
};

export const getTrackingPageForRoute = (route: string): ClientTrackingPage | null => {
    const foundPage: ClientTrackingPage | undefined = routePageViewMap[route];
    if (!foundPage) {
        return null;
    }

    return foundPage;
}

export default routePageViewMap;



// WEBPACK FOOTER //
// ./src/models/route-page-view-tracking.ts